<template>
  <div class="sida-accordion">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data: () => ({

  }),
  methods: {
    addListeners() {
      const onTitleClickHandler = (ev) => {

        const node = ev.target;
        if(node.classList.contains("badge")){
          return;
        }
        const isOpen = node.classList.contains("active");
        this.$el.querySelectorAll(".accordion-title.active").forEach(activeNode => {
          activeNode.classList.remove("active");
        });

        if (!isOpen) {
          node.classList.add("active");
        }
      };

      this.$el.querySelectorAll(".accordion-title").forEach(node => {
        node.removeEventListener("click", onTitleClickHandler);
        node.addEventListener("click", onTitleClickHandler);
      });
    }
  },
  mounted() {
    this.addListeners();
  }
};
</script>
<style lang="scss" scoped>
.sida-accordion {
  .content {
    max-height: 0;
    min-height: 0;
    padding: 0;
    background: #f7f7f7;
    transition: max-height .3s cubic-bezier(0, 1, 0, 1);
    overflow: hidden;

    .container {
      margin: 10px 0px;
    }
  }

  .accordion-title {
    margin: 0;
    border: 1px solid #c5c5c5;
    background: #f6f6f6;
    color: #454545;
    font-weight: normal;
    font-size: 14px;
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
    text-shadow: none;
    text-align: left;

    .btn-delete {
      float: right;
      border: none;
      background: none;
      color: #4e4e4e;
      cursor: pointer;
    }

    &.active {
      background: #31813c;
      color: #fff;
      border-radius: 5px 5px 0 0;

      .btn-delete {
        color: #fff;
      }

      &+.content {
        max-height: 10000px;
        overflow-y: auto;
        transition: max-height 1s ease-in-out;
      }
    }
  }
}
</style>
